const asideMenuPath = {
  CUSTOMER: '/customer',
  DEVICE: '/device',
  TASK: '/task',
  ACCOUNT: '/account',
  SYSTEM: '/system',
  MATCH: '/match',
  SETTINGS: '/settings',
  INSTALL: '/install',
  CHARGE: '/charge',
}

export const asideCustomerPath = {
  CUSTOMER_REGISTER: asideMenuPath.CUSTOMER + '/register',
  CUSTOMER_ALLOCATION: asideMenuPath.CUSTOMER + '/allocation',
  CUSTOMER_INFO: asideMenuPath.CUSTOMER + '/info',
  CUSTOMER_BINARY_CHECK: asideMenuPath.CUSTOMER + '/binary-check',
  CUSTOMER_FLAGGED_REVIEW: asideMenuPath.CUSTOMER + '/flagged-review',
  CUSTOMER_ACTIVITY: asideMenuPath.CUSTOMER + '/activity',
  CUSTOMER_CHECKLIST: asideMenuPath.CUSTOMER + '/checklist',
  CUSTOMER_CHECK_REPORT: asideMenuPath.CUSTOMER + '/check-report',
  CUSTOMER_MINIMUM_FLOW: asideMenuPath.CUSTOMER + '/minimum-flow',
  CUSTOMER_CUSTOMER_STATUS: asideMenuPath.CUSTOMER + '/customer-status',
  CUSTOMER_HDM: asideMenuPath.CUSTOMER + '/customer-hdm',
  CUSTOMER_CUSTOMER_LEAKAGE: asideMenuPath.CUSTOMER + '/customer-leakage',
  CUSTOMER_UNUSED: asideMenuPath.CUSTOMER + '/unused',
  CUSTOMER_FREEZE_WARNING: asideMenuPath.CUSTOMER + '/freeze-warning',
  CUSTOMER_CLIENT: asideMenuPath.CUSTOMER + '/client',
}

export const asideDevicePath = {
  DEVICE_REGISTER: asideMenuPath.DEVICE + '/register',
  DEVICE_ALLOCATION: asideMenuPath.DEVICE + '/allocation',
  DEVICE_INFO: asideMenuPath.DEVICE + '/info',
  DEVICE_IMAGES: asideMenuPath.DEVICE + '/images',
  DEVICE_HISTORY: asideMenuPath.DEVICE + '/history',
}

export const asideTaskPath = {
  TASK_AS: asideMenuPath.TASK + '/as',
  TASK_RECOVERY: asideMenuPath.TASK + '/recovery',
}

export const asideAccountPath = {
  ACCOUNT_GROUP: asideMenuPath.ACCOUNT + '/group',
}

export const asideSystemPath = {
  SYSTEM_CODE: asideMenuPath.SYSTEM + '/code',
}

export const asideMatchPath = {
  MATCH_FOTA: asideMenuPath.MATCH + '/fota',
}

export const asideSettingsPath = {
  SETTINGS_SETUP: asideMenuPath.SETTINGS + '/setup',
}

export const asideInstallPath = {
  INSTALL_CONNECT: asideMenuPath.INSTALL + '/connect',
  INSTALL_STATUS: asideMenuPath.INSTALL + '/status',
  INSTALL_AS: asideMenuPath.INSTALL + '/as',
  INSTALL_AS_COMPLETE: asideMenuPath.INSTALL + '/as/complete',
}

export const asideChargePath = {
  CHARGE_SELECT: asideMenuPath.CHARGE + '/select',
  CHARGE_INFO: asideMenuPath.CHARGE + '/info',
  CHARGE_SETTING: asideMenuPath.CHARGE + '/setting',
}
